import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Chart } from 'chart.js';
import * as _ from 'lodash';
import * as moment from 'moment-timezone';
import { Dashboard2Service } from './dashboard.service'
import { DomSanitizer } from '@angular/platform-browser';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { isEmpty } from 'rxjs/operator/isEmpty';

// Hazard map imports
import { Fill, Stroke } from 'ol/style';
import { defaults as defaultControls, FullScreen } from 'ol/control';
import Map from 'ol/Map';
import View from 'ol/View';
import Feature from 'ol/Feature';
import { fromLonLat } from 'ol/proj.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import { Style } from 'ol/style';
import OSM from 'ol/source/OSM';
import Circle from 'ol/geom/Circle';
import Overlay from 'ol/Overlay';
import { Text } from 'ol/style';
import { Constants } from '../constants';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { UserInspectionStatsComponent } from '../user-inspection-stats/user-inspection-stats.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import { environment } from '../../environments/environment';
import { SubmittedFormFilterService } from '../submitted-form-filter/submitted-form-filter.service';

@Component({
  selector: 'app-dashboard2',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class Dashboard2Component implements OnInit, AfterViewInit {

  // Map options
  map: Map;
  vectorLayer: VectorLayer;
  vectorSource: VectorSource;
  container: any;
  content: any;
  closer: any;
  overlay: any;
  zoom: number = 8;
  selectedHazard: any;

  // options
  heatMapTemplateData: Array<{}> = [];
  public counts: any = {};
  public recentInspections: any = [];
  public activeHazards: any = [];
  public totalHazards: any = [];
  public totalInspections: any = [];
  public inspectionsByTemplate: any = [];
  public age: any = [4, 6, 2, 8];
  public users: any = [];
  public _hlat: number = 0;
  public _hlng: number = 0;
  public _ilat: number = 0;
  public _ilng: number = 0;
  hazardChart;
  isCheked;
  inspectionChart;
  hazardUpdate: boolean = false;
  inspectionUpdate: boolean = false;
  public types: any = [];
  public dueDates: any = [];
  checkHazardData = [];
  filteredTypes = [];
  filteredTemplate;
  filterScheduleData: any;
  scheduleProgress = ['Today', 'This Week', 'This Month'];
  inspectionProgress = ['Today', 'This Week', 'This Month', 'Last 30 Days'];
  currentIndex = 2;
  inspectionCurrentIndex = 3;
  filterInspectionsStatusData = []
  public hazardCoordinates: Array<{}> = [{
    lat: '',
    lng: '',
    id: '',
    taskId: '',
    alpha: 1
  }];
  public inspectionCoordinates: Array<{}> = [{
    lat: '',
    lng: '',
    id: '',
    taskId: '',
    alpha: 1
  }];
  backgroundColor = ["#00441B", "#006D2C", "#006D2C", "#41AB5D", "#74C476", "#A1D99B", "#C7E9C0", "#F7FCF5"];
  public hazardMarkerIcon: String = './assets/images/base-ovel.svg';
  public dummyStats: any = {
    activeHazards: 12,
    fixedHazards: 32,
    totalHazards: 44,
    withHazards: 16,
    withOutHazards: 23,
  };
  typesCard = {
    colorScheme: {
      domain: ['#7847D6'] // '#007AFF']
    },
    animations: true,
    view: [333, 189]
  };
  colorScheme = {
    domain: []
  };
  hazardTrendDummyData: any;
  hazardTrendFixedData: any;
  checkName;
  scheduleInspectionData: any = [];
  inspectionsStatusData:any = [];
  lineGraphColors = ["#0530AD", "#60B5CC", "#E66C7D", "#6BB76D", "#CD7647", "#AF3F3E", "#99C9D9", "#F4C484"]
  monthPick: {year: number, month: number};
  maxDate = {year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate()};
  constructor(
    public _dashboardService: Dashboard2Service,
    private _router: Router,
    private domSanitizer: DomSanitizer,
    private _capabilityEngineService: CapabilityEngineService,
    private constants: Constants,
    private dialog: MatDialog,
    private modalService: NgbModal,
    private filterDeatailservice: SubmittedFormFilterService
  ) { }
  previous;

  canPerform(data) {
    return this._capabilityEngineService.canPerform(data);
  }

  isFormhound() {
    return this._capabilityEngineService.isFormhound();
  }

  clickedMarker(infowindow) {
    if (this.previous) {
      this.previous.close();
    }
    this.previous = infowindow;
  }
  selectMarker(taskId) {
    this._router.navigateByUrl(
      '/submittedFormPreview/' + taskId + '?currentPage=hazards&formType=hazard'
    );
  }
  fixHazardform(taskId) {
    this._router.navigateByUrl(
      '/hazardform/' + taskId + '?currentPage=hazards&formType=hazard'
    );
  }
  complete() {
    let compltedSchedule = [];
    if (this.filterScheduleData && this.filterScheduleData.length > 0) {
      _.forEach(this.filterScheduleData, (val, key) => {
        if (val.status === 1 || val.status === 2) {
          compltedSchedule.push(val)
        }
      })
      if (compltedSchedule.length > 0) {
        return compltedSchedule.length
      } else {
        return 0
      }
    }
  }
  inprogress() {
    let compltedSchedule = [];
    if (this.filterScheduleData && this.filterScheduleData.length > 0) {
      _.forEach(this.filterScheduleData, (val, key) => {
        if (val.status === 0 && val.taskId) {
          compltedSchedule.push(val)
        }
      })
      if (compltedSchedule.length > 0) {
        return compltedSchedule.length
      } else {
        return 0
      }
    }
  }
  pending() {
    let compltedSchedule = [];
    if (this.filterScheduleData && this.filterScheduleData.length > 0) {
      _.forEach(this.filterScheduleData, (val, key) => {
        if (val.status === 0 && !val.taskId) {
          compltedSchedule.push(val)
        }
      })
      if (compltedSchedule.length > 0) {
        return compltedSchedule.length
      } else {
        return 0
      }
    }
  }
  upcomingData() {
    let dummData = [];
    if (this.scheduleInspectionData && this.scheduleInspectionData.length > 0) {
      _.forEach(this.scheduleInspectionData, (val, key) => {
        if (val.scheduleAt) {
          if (moment(val.scheduleAt).utc().format('YYYY-MM-DD') >= moment(new Date()).format('YYYY-MM-DD') && val.status === 0) {
            dummData.push(val);
          }
        }
      })
      dummData.sort((a, b) => a.scheduleAt.localeCompare(b.scheduleAt));
      return dummData;
    } else {
      return dummData
    }
  }
  selectFilter(data, index) {
    let dates = [],
      filter, dummData = [];
    let allScheduleInspection = this.scheduleInspectionData;
    var groups = new Set(
      allScheduleInspection.map(item =>
        moment.utc(item.scheduleAt).local().format("YYYY-MM-DD").substring(0, 10)
      )
    );
    let scheduleInspectionData: any;
    groups.forEach((g: any) =>
      scheduleInspectionData = Object.assign([], scheduleInspectionData, {
        [g]: allScheduleInspection.filter(
          i => moment.utc(i.scheduleAt).local().format("YYYY-MM-DD").substring(0, 10) === g
        )
      })
    );
    if (data && index != undefined) {
      // if (indication === 'uparrow') {
      //   this.currentIndex--;
      //   filter = data[this.currentIndex];
      // } else if (indication === 'downarrow') {
      //   this.currentIndex++;
      //   filter = data[this.currentIndex];
      // }
      filter = data[index];
      this.currentIndex = index;
    } else {
      filter = data
    }
    this.filterScheduleData = [];
    if (filter === 'Today') {
      if (scheduleInspectionData) {
        let curretDate = [moment(new Date()).utc().format('YYYY-MM-DD')]
        _.forEach(curretDate, (val, key) => {
          dummData.push(...scheduleInspectionData[val]);
        })
        this.filterScheduleData = dummData;
      }
    } else if (filter === 'This Week') {
      if (scheduleInspectionData) {
        let totalDays = 7;
        for (let i = 1; i <= totalDays; i++) {
          let date = moment().subtract((totalDays - i), 'days').format('YYYY-MM-DD');
          dates.push(date);
        }
        _.forEach(dates, (val, key) => {
          if (val) {
            dummData.push(...scheduleInspectionData[val]);
          }
        });
        this.filterScheduleData = dummData;
      }

    } else if (filter === 'This Month') {
      if (scheduleInspectionData) {
        const currentMonthDates = new Array(moment().daysInMonth()).fill(null).map((x, i) => moment().startOf('month').add(i, 'days').format('YYYY-MM-DD'));
        _.forEach(currentMonthDates, (val, key) => {
          if (val) {
            dummData.push(...scheduleInspectionData[val]);
          }
        });
        this.filterScheduleData = dummData;
      }
    }
    this.complete();
    this.pending();
    this.inprogress();
    this.upcomingData();
  }
  getAllInspections() {
    this._dashboardService.getAllInspections('month').subscribe(
      (res: any) => {
        this.scheduleInspectionData = res.data;
        this.selectFilter('This Month', undefined);
      }
    )
  }

  getAllInspectionsStatus() {
    this._dashboardService.getAllInspectionsByStatus().subscribe(
      (res: any) => {
        this.inspectionsStatusData = res.data;
        this.selectInspectionsFilter('Last 30 Days', undefined)
      }
    )
  }
  /**
   * @param c : HTML Element classname
   */
  toggleFullScreen(c) {
    let el: HTMLButtonElement = <HTMLButtonElement>document.querySelector('div.' + c + ' button[title="Toggle fullscreen view"]');
    el.click();
  }

  selectedType = "Daily";
  navigateToHazardForm() {
    this._router.navigateByUrl('/formFilling/' + this.getHazardTemplateId() + '?currentPage=hazards');
  }
  zoomIn() {
    this.zoom += 2;
  }
  zoomOut() {
    this.zoom -= 2;
  }

  getHeatMapData(type) {

    var totalDays = 14;
    switch (type) {
      case 'DAILY':
        totalDays = 14;
        break;
      case 'WEEKLY':
        totalDays = 84;
        break;
      case 'MONTHLY':
        totalDays = 360;
        break;
      case 'QUARTERLY':
        totalDays = 1080;
        break;
      default:
        break;
    }

    // Grouping the inspections by date which is formatted first as 'MM/DD'.
    let inspectionsByTemplate = _.groupBy(_.map(this.inspectionsByTemplate, function (t) {
      t.createdAt = moment(t.createdAt).format('MM/DD/YYYY');
      return t;
    }), 'createdAt');

    let dates = [];
    // !starting from index 1 to consider current day.
    // *Got the dates for x-axis
    for (let i = 1; i <= totalDays; i++) {
      let date = moment().subtract((totalDays - i), 'days').format('MM/DD/YYYY');
      dates.push(date);
    }

    var heatMapData = [];

    if (type === 'DAILY') {
      let self = this;
      _.forEach(dates, function (d) {

        // @inspectionDataByDate return the template names for the given date.
        let inspectionDataByDate = inspectionsByTemplate[d] ? inspectionsByTemplate[d] : [];
        _.forEach(self.filteredTemplate, function (t) {
          let name = t.name;
          // Grouping the data by templateId to match the same with all teamplates for the team.
          let inspectionsDataByTemplate = _.groupBy(inspectionDataByDate, 'templateId');
          let value = inspectionsDataByTemplate && inspectionsDataByTemplate[t._id] ? inspectionsDataByTemplate[t._id].length : 0;

          heatMapData.push({
            event: { name: name, value: value },
            level: value > 8 ? 8 : value
          });
        });
      });
    } else if (type === 'WEEKLY') {
      let self = this;
      let monthDates: {} = _.groupBy(dates, (dt) => moment(dt).month());
      _.forEach(monthDates, function (dates, month) {
        let groupedDates: {} = _.groupBy(dates, (dt) => moment(dt).week());
        _.forEach(groupedDates, function (dates: [string], week) {

          var inspectionDataByDate = [];
          _.forEach(dates, (date) => {

            // @inspectionDataByDate return the template names for the given date.
            if (inspectionsByTemplate[date]) {
              inspectionDataByDate.push(...inspectionsByTemplate[date]);
            }
          })
          let currentMonth = new Date().getMonth();
          if (currentMonth - 3 < parseInt(month)) {

            _.forEach(self.filteredTemplate, function (t) {
              let name = t.name;
              // Grouping the data by templateId to match the same with all teamplates for the team.
              let inspectionsDataByTemplate = _.groupBy(inspectionDataByDate, 'templateId');
              let value = inspectionsDataByTemplate && inspectionsDataByTemplate[t._id] ? inspectionsDataByTemplate[t._id].length : 0;

              heatMapData.push({
                event: { name: name, value: value },
                level: value > 8 ? 8 : value
              });
            });
          }
        });
      });
    } else if (type === 'MONTHLY') {
      let groupedDates: {} = _.groupBy(dates, (dt) => moment(dt).month());

      let self = this;
      _.forEach(groupedDates, function (dates: [string], month) {

        var inspectionDataByDate = [];
        _.forEach(dates, (date) => {

          // @inspectionDataByDate return the template names for the given date.
          if (inspectionsByTemplate[date]) {
            inspectionDataByDate.push(...inspectionsByTemplate[date]);
          }
        })

        _.forEach(self.filteredTemplate, function (t) {
          let name = t.name;
          // Grouping the data by templateId to match the same with all teamplates for the team.
          let inspectionsDataByTemplate = _.groupBy(inspectionDataByDate, 'templateId');
          let value = inspectionsDataByTemplate && inspectionsDataByTemplate[t._id] ? inspectionsDataByTemplate[t._id].length : 0;

          heatMapData.push({
            event: { name: name, value: value },
            level: value > 8 ? 8 : value
          });
        });

      });
    } else if (type === 'QUARTERLY') {
      let self = this;
      let groupedDates: {} = _.groupBy(dates, (dt) => moment(dt).year());

      _.forEach(groupedDates, function (dates: [string], year) {
        var inspectionDataByDate = [];
        var quarter = 1;
        let monthDates: {} = _.groupBy(dates, (dt) => moment(dt).month());
        _.forEach(monthDates, function (dates: [string], month) {

          _.forEach(dates, (date) => {

            // @inspectionDataByDate return the template names for the given date.
            if (inspectionsByTemplate[date]) {
              inspectionDataByDate.push(...inspectionsByTemplate[date]);
            }
          })

          let currentYear = new Date().getFullYear();
          let currentMonth = new Date().getMonth();
          if ((currentYear - 3 < parseInt(year)) && ((month === '2' || month === '5' || month === '8' || month === '11') || (currentYear === parseInt(year) && parseInt(month) === currentMonth))) {

            _.forEach(self.filteredTemplate, function (t) {
              let name = t.name;
              // Grouping the data by templateId to match the same with all teamplates for the team.
              let inspectionsDataByTemplate = _.groupBy(inspectionDataByDate, 'templateId');
              let value = inspectionsDataByTemplate && inspectionsDataByTemplate[t._id] ? inspectionsDataByTemplate[t._id].length : 0;

              heatMapData.push({
                event: { name: name, value: value },
                level: value > 8 ? 8 : value
              });
            });

            quarter = 1;
          }
          quarter++;
        });
      });
    }

    return heatMapData;
  }
  daily() {
    let totalDays = 14;
    let dates = [];
    for (let i = 1; i <= totalDays; i++) {
      let date = moment().subtract((totalDays - i), 'days').format('MM/DD');
      if (i === 1) {
        dates.push({ name: date });
      } else if (i === 8) {
        dates.push({ name: date });
      } else {
        dates.push({ name: date });
      }
    }
    this.filteredTypes = dates;
  }
  monthly() {
    let months = [{ name: 'JAN', wkly: 'Q1' }, { name: 'FEB' }, { name: 'MAR' }, { name: 'APR', wkly: 'Q2' }, { name: 'MAY' }, { name: 'JUN' }, { name: 'JUL', wkly: 'Q3' }, { name: 'AUG' }, { name: 'SEP' }, { name: 'OCT', wkly: 'Q4' }, { name: 'NOV' }, { name: 'DEC' }];
    // let totalMonths = 12;
    // for (let i = 1; i <= totalMonths; i++) {
    //   let date = moment().subtract((totalMonths - i), 'months').format('MMM');
    //   if (i === 1) {
    //     months.push({ name: date, wkly: "Q1" });
    //   } else if (i === 4) {
    //     months.push({ name: date, wkly: "Q2" });
    //   } else if (i === 7) {
    //     months.push({ name: date, wkly: "Q3" });
    //   } else if (i === 10) {
    //     months.push({ name: date, wkly: "Q4" });
    //   } else {
    //     months.push({ name: date });
    //   }

    // }
    this.filteredTypes = months;
  }
  weeklies() {

    this.filteredTypes = [];
    let dates = [];
    for (let i = 1; i <= 84; i++) {
      let date = moment().subtract((84 - i), 'days').format('MM/DD/YYYY');
      dates.push(date);
    }
    let self = this;
    let monthDates: {} = _.groupBy(dates, (dt) => moment(dt).month());
    _.forEach(monthDates, function (dates, month) {
      var firstWeek = 0;
      var year = moment(dates[0]).format("MMM YY");
      let groupedDates: {} = _.groupBy(dates, (dt) => moment(dt).week());
      _.forEach(groupedDates, function (dates: [string], week) {

        if (firstWeek === 0) {
          firstWeek = parseInt(week);
        }

        let currentMonth = new Date().getMonth();
        if (currentMonth - 3 < parseInt(month)) {
          self.filteredTypes.push({ name: 'W' + (parseInt(week) - firstWeek + 1), wkly: year, startDate: moment(dates[0]).format("DD"), lastDate: moment(dates[dates.length - 1]).format("DD") });
        }

        year = '';
      })
    })
  }
  quarterlies() {
    let year = moment(new Date()).format("YYYY");
    let quarterlies = [{ name: "Q1", wkly: year - 2 }, { name: "Q2" }, { name: "Q3" }, { name: "Q4" }, { name: "Q1", wkly: year - 1 }, { name: "Q2" }, { name: "Q3" }, { name: "Q4" }]
    this.filteredTypes = quarterlies;
    let month = (new Date().getMonth()) + 1;
    let final = Math.ceil(month / 3);
    for (let i = 1; i <= final; i++) {
      if (i === 1) {
        this.filteredTypes.push({ name: 'Q' + i, wkly: year })
      } else {
        this.filteredTypes.push({ name: 'Q' + i })
      }

    }
  }
  getBase64String(str) {
    return 'data:image/jpg;base64,' + str;
  }
  checkData(type: string) {
    const squares = <HTMLElement>document.querySelector('.squares');

    this._dashboardService.getFormSubmissionData(type)
      .subscribe((data: any) => {
        // console.log(data, 'inspection Data');

        this.filteredTemplate = data.data.templateNames;
        this.inspectionsByTemplate = data.data.inspectionsByTemplate;

        this.heatMapTemplateData = this.getHeatMapData(type);

        squares.style.setProperty('--num-rows', '' + this.filteredTemplate.length);
        squares.style.setProperty('--num-cols', '' + this.filteredTypes.length);
      }, (err) => {
        console.log('​DashboardComponent -> err', err);
      });
  }
  checkHazardTrendData(name) {
    if (name) {
      return name;
    }
  }
  onChange(event, name, clr, index) {
    let hazardDummyArray = [...this.hazardTrendFixedData];

    if (event.checked) {
      if (this.hazardTrendDummyData.length) {
        hazardDummyArray = [...this.hazardTrendDummyData];
      }
      this.hazardTrendDummyData = [];
      _.forEach(this.checkHazardData, (val, key) => {
        if (val.name === name) {
          if (!this.checkName && hazardDummyArray.length === 0) {
            hazardDummyArray = [val];
          } else {
            hazardDummyArray.splice(index, 0, val);
            this.colorScheme.domain.splice(index, 0, clr)
          }
          this.checkName = name;
        }
      });
      this.hazardTrendDummyData = [...hazardDummyArray];
    } else {
      if (this.hazardTrendDummyData.length > 1) {
        if (this.hazardTrendDummyData.length) {
          hazardDummyArray = [...this.hazardTrendDummyData];
        }
        const index = hazardDummyArray.findIndex(order => order.name === name);
        hazardDummyArray.splice(index, 1);
        this.colorScheme.domain.splice(index, 1)
        this.hazardTrendDummyData = [...hazardDummyArray];
        if (this.hazardTrendDummyData.length === 1) {
          _.forEach(this.hazardTrendDummyData, (val, key) => {
            this.isCheked = val.name;
          });
        }
      }
    }
  }
  ngOnInit(): void {


    if (this.canPerform(['viewHazardList'])) {
      this._dashboardService.getCounts()
      .subscribe((data: any) => {
        // console.log(data, 'inspection Data');

        this.counts = data.data.counts;
        // this.stats = this.dummyStats;
        let _gpsCoordinates = _.groupBy(data.data.gpsCoordinates, 'taskType');
        // Hazard Maps setup
        this.hazardCoordinates = _.map(_gpsCoordinates['HAZARD'], function (a) {
          return { lat: parseFloat(a.gpsCoordinates.lat), lng: parseFloat(a.gpsCoordinates.long), alpha: 1, id: a.id, taskId: a.taskId };
        });
        let latestHazardCoordinate = _.orderBy(_gpsCoordinates['HAZARD'], 'createdAt', 'desc')[0];
        this._hlat = latestHazardCoordinate ? parseFloat(latestHazardCoordinate.gpsCoordinates.lat) : 0;
        this._hlng = latestHazardCoordinate ? parseFloat(latestHazardCoordinate.gpsCoordinates.long) : 0;

        // Hazard map center
        this.centerMap(this._hlng, this._hlat);

        // Inspection Maps setup
        this.inspectionCoordinates = _.map(_gpsCoordinates['INSPECTION'], function (a) {
          return { lat: parseFloat(a.gpsCoordinates.lat), lng: parseFloat(a.gpsCoordinates.long), alpha: 1, id: a.id, taskId: a.taskId };
        });
        let latestInspectionCoordinate = _.orderBy(_gpsCoordinates['INSPECTION'], 'createdAt', 'desc')[0];
        this._ilat = latestHazardCoordinate ? parseFloat(latestInspectionCoordinate.gpsCoordinates.lat) : 0;
        this._ilng = latestHazardCoordinate ? parseFloat(latestInspectionCoordinate.gpsCoordinates.long) : 0;

        this.activeHazards = [{
          name: 'Total',
          value: this.counts.activeHazards > 0 ? this.counts.activeHazards : 0
        }];

        this.totalHazards = [{
          name: 'Total Inspection(s)',
          value: this.counts.totalHazards > 0 ? this.counts.totalHazards : 0
        }];
        this.totalInspections = [{
          name: 'Total Inspection(s)',
          value: (this.counts.withHazards + this.counts.withOutHazards) > 0 ? (this.counts.withHazards + this.counts.withOutHazards) : 0
        }];
        this.age = [{
          name: 'Past Week',
          value: data.data.ageOfHazard.firstWeek > 0 ? data.data.ageOfHazard.firstWeek : 0
        },
        {
          name: '1-2 Weeks',
          value: data.data.ageOfHazard.secondWeek > 0 ? data.data.ageOfHazard.secondWeek : 0
        },
        {
          name: '2-3 Weeks',
          value: data.data.ageOfHazard.thirdWeek > 0 ? data.data.ageOfHazard.thirdWeek : 0
        },
        {
          name: '3+ weeks',
          value: data.data.ageOfHazard.pastWeeks > 0 ? data.data.ageOfHazard.pastWeeks : 0
        }
        ];

        this.hazardCoordinates.forEach((hazard) => {
          if (hazard["lng"] && hazard["lat"]) {
            this.drawMarker(hazard["lng"], hazard["lat"], hazard["taskId"]);
          }
        });

        if (data.data.hazardsByDueDate.length !== 0) {
          let results = [];
          data.data.hazardsByDueDate.forEach((hazard) => {
            if (moment(hazard.data.hDueDate).isValid()) {
              results.push({
                workorderId: hazard.data.newWorkOrder,
                value: moment(hazard.data.hDueDate).format('L'),
                image: (hazard.data.hazardImages && hazard.data.hazardImages.length > 0) ? hazard.data.hazardImages[0].thumbnail : undefined,
                _id: hazard._id
              });
            }
          });
          // Sorting by date and limiting the dataset to 6
          results = results.slice(0, 12);
          this.dueDates = results;
        }
        //  else {
        //   this.dueDates = [{
        //     name: 'No Hazards',
        //     value: 0
        //   }];
        // }
      }, (err) => {
        console.log('​DashboardComponent -> err', err);
      });

      this.getHazardsByType();
    }

    this.getAllInspections();
    this.getAllInspectionsStatus()
    //To Show Dialies data
    this.daily();
    this.checkData('DAILY');

    // calling recent inspections service
    this._dashboardService.getRecentInspections()
      .subscribe((data: any) => {
        _.map(data.data, (form) => {
          if (form.formName !== "Safety Share") {
            this.recentInspections.push(form);
          }
        });
        // console.log(this.recentInspections , 'recentInspections');

        this.recentInspections.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
      }, (err) => {
        console.log('​DashboardComponent -> err', err);
      });
  }

  ngAfterViewInit() {
    this.initializeMap();
  }

  initializeMap() {
    this.container = document.getElementById('popup');
    this.content = document.getElementById('popup-content');
    this.closer = document.getElementById('popup-closer');

    this.overlay = new Overlay({
      element: this.container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      }
    });

    let raser = new TileLayer({
      source: new OSM()
    });
    this.vectorSource = new VectorSource({wrapX: false});
    this.vectorLayer = new VectorLayer({
      source: this.vectorSource
    });

    this.map = new Map({
      target: 'map',
      view: new View({
        center: [0, 0],
        zoom: this.zoom
      }),
      layers: [
        raser,
        this.vectorLayer
      ],
      overlays: [this.overlay],
      controls: defaultControls({
        attributionOptions: {
          collapsible: false
        }
      }).extend([new FullScreen()])
    });

    this.map.on('click', (event) => {
      const feature = this.map.forEachFeatureAtPixel(event.pixel, (feat, layer) => { return feat });
      if(!feature) {
        return;
      }

      let id = feature.get('name');
      this.selectedHazard = _.find(this.hazardCoordinates, (hazard) => { return hazard["taskId"] === id });

      this.content.innerHTML = '<p style="cursor: pointer;"><code>' + this.selectedHazard["taskId"] + '</code></p>';
      this.overlay.setPosition(event.coordinate);
    });


    this.closer.onclick = () => {
      this.overlay.setPosition(undefined);
      this.closer.blur();
      return false;
    };
  }

  drawMarker(longitude, latitude, taskId) {

    let layer = new VectorLayer({
      source: new VectorSource({
        projection: 'EPSG:4326',
        features: [new Feature({name: taskId, geometry: new Circle(fromLonLat([longitude, latitude]), 20)})]
      }),
      style: [
        new Style({
          stroke: new Stroke({
            color: '#d95015',
            width: 4
          }),
          fill: new Fill({
            color: 'rgba(164, 95, 60, 0.1)'
          }),
          text: new Text({
            font: 'bold 12px Calibri,sans-serif',
            fill: new Fill({ color: '#000' }),
            stroke: new Stroke({
                color: '#fff',
                width: 2
            }),
            text: this.map.getView().getZoom() > 12 ? taskId  : ""
          })
        })
      ],
      radius: 200
    });

    this.map.addLayer(layer);
  }

  centerMap(longitude, latitude) {
    this.map.getView().setCenter(fromLonLat([longitude, latitude]));
    this.map.getView().setZoom(12);
  }

  navToHazard() {
    if (!this.selectedHazard && !this.selectedHazard["id"]) {
      return;
    }
    this._router.navigateByUrl(
      '/submittedFormPreview/' + this.selectedHazard["id"] + '?currentPage=hazards'
    );
  }

  getFirstLetterString(name) {
    if (name) {
      let result = '';
      let splitArray = name.split(' ');
      if (name.length === 1) {
        result = name;
      } else if (splitArray.length === 1) {
        result = splitArray[0][0] + splitArray[0][1];
      } else {
        _.forEach(splitArray, function (word) {
          result = result.concat(word[0]);
        });
      }
      return result.substring(0, 2);
    }
  }

  axisFormat(val) {
    if (val % 1 === 0) {
      return val.toLocaleString();
    } else {
      return '';
    }
  }

  getHazardsByType() {
    this._dashboardService.getHazardsByTypeTrends('week')
      .subscribe((data: any) => {
        if (data.data.Electrical || data.data.Guarding || data.data.Housekeeping || data.data.Other) {
          let dummData = [];
          //var series = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          var series = [];
          for (var i = 11; i > -1; i -= 1) {
            let month = moment().subtract(i, "months").format("MMM");
            series.push(month);
          }
          let checkHazardTrendData = (data, hName) => {
            if (data) {
              let hazardTrendData = _.groupBy(_.map(data, function (t) {
                t.createdAt = moment(t.createdAt).format("MMM");
                return t;
              }), 'createdAt');
              let monthsData = []
              _.forEach(series, (val, key) => {
                monthsData.push({ name: val, value: hazardTrendData[val] ? hazardTrendData[val].length : 0 })
              });
              dummData.push({
                "name": hName,
                "series": monthsData
              });
              this.hazardTrendDummyData = [...dummData];
              this.hazardTrendFixedData = [...dummData];
              this.checkHazardData = [...this.hazardTrendDummyData];
            } else {
              let monthsData = []
              _.forEach(series, (val, key) => {
                monthsData.push({ name: val, value: 0 })
              });
              dummData.push({
                "name": hName,
                "series": monthsData
              });
              this.hazardTrendDummyData = [...dummData];
              this.hazardTrendFixedData = [...dummData];
              this.checkHazardData = [...this.hazardTrendDummyData];
            }
          }
          this.colorScheme.domain = []
          if(data['data']) {
            if(Object.keys(data['data']).length > 0) {
              _.forEach(Object.keys(data['data']), (trend, i) => {
                if(trend != "undefined") {
                  checkHazardTrendData(data['data'][trend], trend);
                }
              })
            }
            _.forEach(this.hazardTrendDummyData, (e, i) => {
              this.colorScheme.domain.push(this.lineGraphColors[i])
            })
          }
        } else {
          this.hazardTrendDummyData = [];
          this.hazardTrendFixedData = [];
        }
      }, (err) => {
        console.log('​DashboardComponent -> err', err);
      });
  }
  selectedItemType(filter) {
    var tagKey;
    switch (filter) {
      case 'Daily':
        tagKey = 'DAILY';
        this.daily();
        break;
      case 'Weekly':
        tagKey = 'WEEKLY';
        this.weeklies();
        break;
      case 'Monthly':
        tagKey = 'MONTHLY';
        this.monthly();
        break;
      case 'Quarterly':
        tagKey = 'QUARTERLY';
        this.quarterlies();
        break;
      default:
        break;
    }

    this.checkData(tagKey);
    this.selectedType = filter;
  }

  selectInspectionsFilter(data, index) {
    let dates = [],
    filter, dummData = [];
    let allScheduleInspection = this.inspectionsStatusData;
    var groups = new Set(
      allScheduleInspection.map(item =>
        moment.utc(item.updatedAt).local().format("YYYY-MM-DD").substring(0, 10)
      )
    );
    let scheduleInspectionData: any;
    groups.forEach((g: any) =>
      scheduleInspectionData = Object.assign([], scheduleInspectionData, {
        [g]: allScheduleInspection.filter(
          i => moment.utc(i.updatedAt).local().format("YYYY-MM-DD").substring(0, 10) === g
        )
      })
    );
    if (data && index != undefined) {
      filter = data[index];
      this.inspectionCurrentIndex = index
    } else {
      filter = data
    }
    this.filterInspectionsStatusData = [];
    if (filter === 'Today') {
      if (scheduleInspectionData) {
        let curretDate = [moment(new Date()).utc().format('YYYY-MM-DD')]
        _.forEach(curretDate, (val, key) => {
          dummData.push(...scheduleInspectionData[val]);
        })
        this.filterInspectionsStatusData = dummData;
      }
    } else if (filter === 'This Week') {
      if (scheduleInspectionData) {
        let totalDays = 7;
        for (let i = 1; i <= totalDays; i++) {
          let date = moment().subtract((totalDays - i), 'days').format('YYYY-MM-DD');
          dates.push(date);
        }
        _.forEach(dates, (val, key) => {
          if (val) {
            dummData.push(...scheduleInspectionData[val]);
          }
        });
        this.filterInspectionsStatusData = dummData;
      }

    } else if (filter === 'This Month') {
      if (scheduleInspectionData) {
        const currentMonthDates = new Array(moment().daysInMonth()).fill(null).map((x, i) => moment().startOf('month').add(i, 'days').format('YYYY-MM-DD'));
        _.forEach(currentMonthDates, (val, key) => {
          if (val) {
            dummData.push(...scheduleInspectionData[val]);
          }
        });
        this.filterInspectionsStatusData = dummData;
      }
    } else if (filter == "Last 30 Days") {
      let totalDays = 30;
      for (let i = 1; i <= totalDays; i++) {
        let date = moment().subtract((totalDays - i), 'days').format('YYYY-MM-DD');
        dates.push(date);
      }
      _.forEach(dates, (val, key) => {
        if (val) {
          dummData.push(...scheduleInspectionData[val]);
        }
      });
      this.filterInspectionsStatusData = dummData;
    }

    this.completedInspectionsStatus();
    this.reviewedInspectionsStatus();
    this.submittedInspectionsStatus();
    this.inprogressInspectionsStatus();
  }

  completedInspectionsStatus() {
    let compltedSchedule = [];
    if (this.filterInspectionsStatusData && this.filterInspectionsStatusData.length > 0) {
      let statusGroup = _.groupBy(this.filterInspectionsStatusData, 'status');

      if(statusGroup["undefined"]) {
        delete statusGroup["undefined"];
      }
      _.isEmpty(statusGroup["1"]) ? statusGroup["1"] = [] : '';
      _.isEmpty(statusGroup["2"]) ? statusGroup["2"] = [] : '';
      return statusGroup["1"].length + statusGroup["2"].length;
    }
    return 0;
  }

  reviewedInspectionsStatus() {
    let compltedSchedule = [];
    if (this.filterInspectionsStatusData && this.filterInspectionsStatusData.length > 0) {
      let statusGroup = _.groupBy(this.filterInspectionsStatusData, 'status');
      return statusGroup["2"] && statusGroup["2"].length ? statusGroup["2"].length : 0;
    }
    return 0;
  }

  submittedInspectionsStatus() {
    let submitted = [];
    if (this.filterInspectionsStatusData && this.filterInspectionsStatusData.length > 0) {
      let statusGroup = _.groupBy(this.filterInspectionsStatusData, 'status');
      return statusGroup["1"] && statusGroup["1"].length ? statusGroup["1"].length : 0;
    }
    return 0;
  }
  inprogressInspectionsStatus() {
    let inProgress = [];
    if (this.filterInspectionsStatusData && this.filterInspectionsStatusData.length > 0) {
      let statusGroup = _.groupBy(this.filterInspectionsStatusData, 'status');
      return statusGroup["0"] && statusGroup["0"].length ? statusGroup["0"].length : 0;
    }
    return 0;
  }

  getHazardTemplateId() {
    if(localStorage.getItem("hazardTemplateId")) {
      return localStorage.getItem("hazardTemplateId")
    } else {
      return this.constants.HAZARD_TEMPLATE_ID
    }
  }

  getInspectionStatsByUser() {
    let result = _.forEach(_.groupBy(_.cloneDeep(this.filterInspectionsStatusData), (inspection) => {
      return inspection.submittedBy.name
    }), (inspection) => {
      _.forEach(inspection, (individualInspection: any) => {
        individualInspection.status = 1
      })
    })

    let reviewedInspections = _.groupBy(_.cloneDeep(this.filterInspectionsStatusData), (inspection) => {
      if(inspection.reviewedBy) {
          return inspection.reviewedBy.name
      }
    })

    if(reviewedInspections['undefined']) {
        delete reviewedInspections['undefined']
    }

    let tempReviewedInspections = _.cloneDeep(reviewedInspections)
        // Making reviewed submissions forms status to 2 - Reviewed
    _.forEach(tempReviewedInspections,(userInspections) => {
        _.forEach(userInspections, (inspection: any) => {
            inspection.status = 2
        })

    })

    Object.keys(tempReviewedInspections).forEach((user) => {
      if(result[user]) {
          result[user].push(...tempReviewedInspections[user])
      } else {
          result[user] = tempReviewedInspections[user]
      }
  })



    let userDetails = {}

    for(let user of Object.keys(result)) {
      userDetails[user] = {}
      let submitted = _.groupBy(result[user], (inspection: any) => { return inspection.status })["1"]

      userDetails[user]['submitted'] = submitted ? submitted.length : 0

      let reviewed = _.groupBy(result[user], (inspection: any) => {return inspection.status})["2"]
      userDetails[user]['reviewed'] = reviewed ? reviewed.length : 0
    }
    // return userDetails
    let modalOptions: any = {
        size: 'md',
        centered: true,
        windowClass: 'lg-dialog-medium',
    };
    const modalRef = this.modalService.open(UserInspectionStatsComponent, modalOptions)
    modalRef.componentInstance.user = userDetails
  }

  downloadInspectionStats() {

    let monthObj: any = _.cloneDeep(this.monthPick);
    

    let date = new Date(monthObj.year, monthObj.month - 1, 1, 0, 0, 0, 0);

    let start = moment(date).utc().format();
    let end = moment(date).endOf('month').utc().format()

    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let fromDate = moment(date).startOf('month').format("MM-DD-YYYY");
    let toDate = moment(date).endOf('month').format("MM-DD-YYYY");
    
    let reqObj = {
      start: start,
      end: end,
      month: moment(end).format("MMMM'YYYY")
    }

    console.log(end)


    this._dashboardService.getNewInspectionReportExcel(reqObj)
    // this._dashboardService.getInspectionStatsExcel(reqObj)
        .toPromise().then((data: any) => {
        let folderName = '';
        
        folderName = (environment.APP_NAME || '') + ' Inspection Stats Report ' + fromDate + " to " + toDate;
        const blob = new Blob([data['body']], {
            type: 'application/xlsx'
        });
        saveAs(blob, `${folderName}.xlsx`);
    });
  }

  onRecentInspectionClick(inspection) {
    let url = `/submittedFormPreview/${inspection.inspectionId}?formType=inspection`
    this._router.navigateByUrl(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard2/dashboard.component.ts